const ORGANIC = [
    'keywords',
    'lostkeywords',
    'sitepages',
    'lostpages',
    'treepages',
    'concurents',
];
const LINKS = [
    'backlinks',
    'outlinks',
    'backlinks-domains',
    'outlinks-domains',
    'backlinks-ip',
    'backlinks/toppages',
    'backlinks-anchor',
];
const CONTEXT = [
    'adkeys',
    'ads',
    'adconcurents',
];
const AI_ANSWERS = [
    'ai-answers',
];
const ORGANIC_GROUP = [
    'main',
    'concurents',
    'sitepages',
];
const CONTEXT_GROUP = [
    'adkeys',
    'adconcurents',
    'ads',
];
// страницы раздела «Яндекс Директ» и его архива: поиск — в /report своего раздела
const YANDEX_DIRECT = [
    'yandex-direct/ads',
    'yandex-direct-archive/domain',
    'yandex-direct-archive/adkeys',
    'yandex-direct-archive/ads',
];

export const Pages = {
    ORGANIC: ORGANIC,
    LINKS: LINKS,
    CONTEXT: CONTEXT,
    AI_ANSWERS: AI_ANSWERS,
    ORGANIC_GROUP: ORGANIC_GROUP,
    CONTEXT_GROUP: CONTEXT_GROUP,
    YANDEX_DIRECT: YANDEX_DIRECT,
};
